// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3gvyu","messages":"Chat_messages__2Wix8","dateDivider":"Chat_dateDivider__34TjA"};